import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallError({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#D85145" cx={8} cy={8} r={8} />
        <path
          d="M8 9.75A1.13 1.13 0 118 12a1.13 1.13 0 010-2.25zM8.5 4c.28 0 .5.22.5.5v3.75a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V4.5c0-.28.22-.5.5-.5h1z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgTickSmallError.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallError.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallError svgRef={ref} {...props} />);
export default ForwardRef;
